import { type IUserDTO, useAuth } from '@gbs-monorepo-packages/auth';
import { type Roles } from '@gbs-monorepo-packages/common';

import { validateUserPermissions } from '../utils/validateUserPermissions';

export interface IUseCanParams {
  permissions?: string[];
  roles?: Roles[];
}

/**
 * @deprecated
 */
export const useCan = (
  { permissions, roles }: IUseCanParams,
  userToValidate: IUserDTO | null = null
): boolean | null => {
  const { user: userFromAuth } = useAuth();

  const user = userToValidate ?? userFromAuth;
  if (!user) {
    return null;
  }

  const userHasValidPermissions = validateUserPermissions({
    user,
    permissions,
    roles,
  });

  return userHasValidPermissions;
};
